import React, { Component, Fragment } from "react";
import cookieManager from "../../../../utils/cookieManager";
import i18n from "../../../../i18n";
import { Table } from "react-bootstrap";
import { faArrowDown, faWeight } from "@fortawesome/free-solid-svg-icons";
import PhotoGallery from "../../../utilities/PhotoGallery";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import DropzoneCustom from "../../../utilities/Form/DropzoneCustom";
const token = cookieManager.getUserToken();

export class DetailBudget extends Component {
  constructor(props) {
    super(props);
    this.state = {
      detail: [],
      change: [],
      check: 0,
    };
  }

  filterImages(data,removeFile){
    if(removeFile.length >0){
        data.map((file)=>{
          let id=file.id
          if(removeFile.includes(id)){
            return Object.assign(file,{status:2});
          }else{
            return file;
          }
        })
    }
    return data
  }
  render() {
    const { choose } = this.props;

    if (choose != null && this.state.check == 0) {
      // this.state.detail = choose.log_value.detail;
      // this.state.change = choose.change_value.detail;
      this.state.headerV = choose.log_value.header;
      // this.state.headerC = choose.change_value.header;
      this.state.check = 1;
    }
    console.log('headerV.file_data', this.state.headerV.file_data);
  console.log('headerV.file', this.state.headerV.file);
    return (
      <React.Fragment>
      <div className="row">
        <div className="col-12">
          <Table rules="cols">
            <thead></thead>
            <tbody>
              <tr>
                <td></td>
                <td></td>
                <td style={{fontWeight:'bold',fontSize:'18px'}}>DATA ASLI</td>
                {/* <td style={{fontWeight:'bold',fontSize:'18px'}}>DATA YANG DIUBAH</td> */}
              </tr>
              <tr>
                <td colSpan={"4"}>
                  <hr/>
                </td>
              </tr>
              <tr style={{ fontSize: "15px", fontWeight: "bold" , padding: "5",}}>
                <td>{i18n.t("Branch Name")}</td>
                <td>:</td>
                <td>
                  {this.state.headerV.branch
                    ? this.state.headerV.branch
                    : "-"}
                </td>
              </tr>
              <tr style={{fontSize: "15px",fontWeight: "bold",}}>
                <td>{i18n.t("Date")}</td>
                <td>:</td>
                <td>
                  {this.state.headerV.date ? this.state.headerV.date : "-"}
                </td>
              </tr>
              <tr style={{fontSize: "15px",fontWeight: "bold",}}>
                <td>{i18n.t("Name")}</td>
                <td>:</td>
                <td>
                  {this.state.headerV.configName ? this.state.headerV.configName : "-"}
                </td>
              </tr>
              <tr style={{fontSize: "15px",fontWeight: "bold",}}>
                <td>{i18n.t("Account")}</td>
                <td>:</td>
                <td>
                  {this.state.headerV.COA3Name.ACC3Name ? this.state.headerV.COA3Name.ACC3Name : "-"}
                </td>
              </tr>
               <tr style={{fontSize: "15px",fontWeight: "bold",}}>
                <td>{i18n.t("Limit")}</td>
                <td>:</td>
                <td>
                  {this.state.headerV.limit_format ? this.state.headerV.limit_format : "-"}
                </td>
              </tr>
              {this.state.headerV.file.length > 0 ? (
                  <tr style={{ fontSize: "15px", fontWeight: "bold" }}>
                    <td>{i18n.t("File")}</td>
                    <td>:</td>
                    <td>
                      <PhotoGallery images={this.state.headerV.file}></PhotoGallery>
                    </td>
                  </tr>
                ) : null}
             
            </tbody>
          </Table>
        </div>
      </div>
    </React.Fragment>
    )
  }
}

export default DetailBudget;
const loader={
  alignItems: 'center',
  background: '#FFF',
  display: 'flex',
  flexDirection:'column',
  height: '100vh',
  justifyContent: 'center',
  left: 0,
  position: 'fixed',
  top: 0,
  transition: 'opacity 0.2s linear',
  width: '100%',
  opacity: 1,
  transform: 'opacity 1s linear',
}